import React, { useEffect, useState } from "react";
// import ordered from "../../assets/images/dashboard/designer.jpg";
import { queryString } from "../../utils/queryString";
import Breadcrumb from "../common/breadcrumb";
import { getOrderDetailsByOrderId } from "./../../reducers/adminReducers";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import { Button } from "react-bootstrap";
import Loader from "../loader/loader";
import logo from "../../assets/images/boxilogof.png";
import "./invoicePrint.css"; //
const InvoiceDetail = () => {
  const { id } = queryString();
  const dispatch = useDispatch();
  const result = useSelector((state) => state.admin);
  const { orderDetails } = result || {};
  const [loading, setLoading] = useState(false);

  const createAddress = (data) => {
    let address = "";
    if (data) {
      [
        "firstname",
        "lastname",
      ].forEach((el) => {
        if (data[el]) {
          address = `${address ? `${address}` : address} ${data[el]}`;
        }
      });
    }
    return address;
  };

  const getOrderDetailsByIdInvoice = async () => {
    setLoading(true);
    const response = await dispatch(getOrderDetailsByOrderId(id));
    if (response?.payload) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOrderDetailsByIdInvoice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const total = () => {
    return orderDetails?.reduce(
      (s, { price, quantity }) => s + price * quantity,
      0
    );
  };

  const handlePrint = () => {
    window.print();
  };

  const invoiceDetials = orderDetails && orderDetails[0];

  return (
    <>
      {loading && <Loader />}
      <div className="admin-order-invoice">
        <Breadcrumb title="orderdetail" parent="order-management" />
        <Button onClick={handlePrint}>Print</Button>
      </div>
      <div className="order-invoice-template">
        <div>
          <table
            style={{
              width: "100%",
              height: "auto",
              textAlign: "center",
            }}
            border={0}
            cellSpacing={0}>
            <tbody style={{ background: "#ffff", padding: "20px" }}>
              <tr>
                <td colSpan={2}>
                  <h1 className="text-capitalize">WOW! Dropbox</h1>
                </td>
                <td colSpan={2} style={{ textAlign: "right" }}>
                  <img style={{ width: "100px" }} src={logo} alt="logo" />
                </td>
              </tr>
              {/* <tr>
                <td colSpan={4}>
                  <p>
                    <b>ADDRESS :</b>
                  </p>
                </td>
              </tr> */}
              <tr className="address-section">
                <td colSpan={3}>
                  <p>
                    <strong>User Name :</strong> {createAddress(invoiceDetials?.orderId?.shippingAddress)}
                  </p>
                  <p>
                    <strong>Mobile :</strong> {invoiceDetials?.userId?.mobile}
                  </p>
                </td>
                <td colSpan={2} style={{ textAlign: "left" }}>
                  <div className="invoice-no">
                    <h6>Order Id :</h6>{" "}
                    <span>{invoiceDetials?.orderId?.orderid}</span>
                  </div>
                  <div className="invoice-no">
                    {" "}
                    <h6>DATE : </h6>{" "}
                    <span>
                      {moment(invoiceDetials?.updatedAt).format("DD MMMM YYYY")}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <table
            style={{
              width: "100%",
              height: "auto",
              backgroundColor: "#fff",
              padding: "20px",
              fontSize: "12px",
              marginTop: "60px",
            }}>
            <thead>
              <tr
                style={{
                  color: "#6c757d",
                  fontWeight: "bold",
                  padding: "5px",
                  border: "1.8px solid #ed0f0f",
                  borderLeft: "0px",
                  borderRight: "0px",
                }}>
                <td style={{ padding: "5px", textAlign: "left" }}>S.No</td>
                <td style={{ textAlign: "right", paddingLeft: "5px" }}>
                  Product
                </td>
                <td style={{ textAlign: "right", paddingLeft: "5px" }}>
                  Quantity
                </td>
                <td style={{ textAlign: "right", padding: "5px" }}>Amount</td>
              </tr>
            </thead>
            <tbody>
              {orderDetails?.length > 0 &&
                orderDetails?.map((el, index) => (
                  <tr>
                    <td style={{ width: "10%" , textAlign: "center" }}> {index + 1}</td>

                    <td
                      style={{
                        width: "20%",
                        marginLeft: "10px",
                        textAlign: "right",
                      }}>
                      {el?.productId?.name}
                    </td>

                    <td
                      style={{
                        width: "20%",
                        padding: "10px",
                        textAlign: "right",
                        color: "black",
                      }}>
                      {el?.quantity}
                    </td>
                    <td
                      style={{
                        width: "30%",
                        fontWeight: "bold",
                        fontSize: "14px",
                        textAlign: "right",
                      }}>
                      $ {el?.price * el?.quantity}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <table
            style={{
              width: "100%",
              height: "auto",
              backgroundColor: "#fff",
              padding: "20px",
              fontSize: "12px",
              marginTop: "100px",
            }}>
            <tbody>
              <tr style={{ padding: "20px", color: "#000", fontSize: "15px" }}>
                <td></td>
                <td></td>
                <td
                  style={{
                    fontWeight: "bold",
                    paddingTop: "100px",
                    textAlign: "right",
                  }}>
                  <h6>TOTAL Amount</h6>
                </td>

                <td
                  style={{
                    textAlign: "right",
                    padding: "5px 0px",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}>
                  <h6>$ {total()}</h6>
                </td>
              </tr>
              <tr>
                <td className="text-right" colSpan={3}>
                  <p className="font-weight-bold">
                    VAT <span className="text-capitalize">Included</span>{" "}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
export default InvoiceDetail;
